exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-top-line {\n  margin-top: 1em;\n  border-top: 1px solid #dadada;\n}\n.c-btn__icon-off {\n  padding: 11px;\n}\n.url-input + .c-btn__icon-off {\n  right:30px;\n}\n@media screen and (min-width: 896px) {\n.pcw-60 {\n    width:60%;\n}\n.url-input {\n    width:60%;\n}\n}\n@media screen and (max-width: 896px) {\n.spw-90 {\n    width:90%;\n}\n.url-input {\n    width:100%;\n}\n.c-btn__icon-off {\n    width: 7vw;\n    height: 7vw;\n    right: 0;\n}\n.url-input +.c-btn__icon-off {\n    right: 12px;\n    top: 8px;\n    position: absolute;\n}\n}\n", ""]);

// exports
